import { ReactNode } from "react";

function Quote({ children }: { children: ReactNode }) {
  return (
    <span>
      «&nbsp;<span className="font-semibold">{children}</span>&nbsp;»
    </span>
  );
}

export { Quote };
